<template>
  <div class="team-invitation-container">
    <el-tabs
      v-model="inviteType"
      @tab-change="choiceInviteType"
    >
      <el-tab-pane
        :label="$t('views.user_center.qrcode_invitation')"
        name="qrcode"
        :disabled="saveLoading"
      >
        <div
          v-loading="loading"
          class="team-qrcode"
        >
          <div class="team-qrcode-box">
            <div
              ref="teamInviteQrCode"
              height="200px"
              style="display: none;"
            />
            <img
              v-if="teamInfo.avatar"
              ref="qrCodeIco"
              :src="teamInfo.avatar"
              crossOrigin="anonymous"
              style="object-fit: contain;display: none"
            >
            <canvas
              ref="teamQrCodeCanvas"
              class="team-qrcode-canvas"
              width="200"
              height="200"
            />
            <button
              class="down-load-box"
              type="button"
              :disabled="loading || !qrCodeImgIsLoad"
              :aria-label="$t('views.user_center.team_invite_download_qr')"
              :title="$t('views.user_center.team_invite_download_qr')"
              @click="downQrcodeImg"
            />
            <a
              ref="qrCodedownload"
              href="#"
              download="teamInviteQrCode.png"
            />
          </div>
        </div>
        <div
          v-if="inviteCode"
          class="team-invite-code"
        >
          <span>{{ $t('views.user_center.invitation_code') }}:</span>
          <span class="team-invite-code-value">{{ inviteCode }}</span>
          <el-button
            type="primary"
            link
            :disabled="loading"
            @click="inviteLinkCopy('inviteCode')"
          >
            {{ $t('common.copy') }}
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$t('views.user_center.link_invitation')"
        name="link"
        :disabled="saveLoading"
      >
        <div v-loading="loading">
          <el-input
            ref="inviteLink"
            v-model="inviteLink"
            :readonly="true"
          >
            <template #append>
              <button
                class="link-copy"
                type="button"
                :disabled="loading || !inviteLink"
                @click="inviteLinkCopy('inviteLink')"
              >{{ $t('common.copy') }}
              </button>
            </template>
          </el-input>
        </div>

      </el-tab-pane>
      <!--      <el-tab-pane
        :label="$t('team.invitation_code')"
        name="invitation-code"
      >
        <div v-loading="loading">
          <el-input
            ref="inviteCode"
            v-model="inviteCode"
            :readonly="true"
          >
            <template #append>
              <div
                class="link-copy"
                @click="inviteLinkCopy('inviteCode')"
              >{{ $t('common.copy') }}
              </div>
            </template>
          </el-input>
        </div>

      </el-tab-pane>-->
<!--      <el-tab-pane
        :label="$t('views.user_center.mobile_invitation')"
        name="phone"
        :disabled="saveLoading"
      >
        <div
          v-loading="loading"
          class="invite-phone-box"
        >
          <el-form
            ref="invitePhoneForm"
            :model="invitePhoneForm"
            :disabled="saveLoading"
            label-width="var(--team-entry-label-width, 100px)"
            class="demo-dynamic"
            @submit.prevent="submitInviteForm"
          >
            <el-form-item
              v-for="(phone, index) in invitePhoneForm.phones"
              :key="phone.key"
              :label="$t('views.user_center.mobile_phone')"
              :prop="'phones.' + index + '.value'"
              :rules="[
                { required: true, message: $t('views.user_center.enter_your_mobile_phone_number'), trigger: 'blur' },
                { validator: validatePhone, trigger: ['blur', 'change'] }
              ]"
            >
              <div class="invite-phone-input">
                <el-input
                  :id="'team-invite-phone-' + phone.key"
                  v-model="phone.value"
                  type="tel"
                  inputmode="tel"
                  autocomplete="tel"
                />
              </div>
              <div class="invite-phone-actions">
                <el-button
                  v-show="(index+1)===invitePhoneForm.phones.length"
                  size="small"
                  type="success"
                  icon="Plus"
                  round
                  :aria-label="$t('views.user_center.team_invite_add_phone')"
                  @click.prevent="addPhone(phone)"
                />
                <el-button
                  v-show="!((index+1)==1&&invitePhoneForm.phones.length==1)"
                  size="small"
                  type="danger"
                  round
                  icon="Delete"
                  :aria-label="$t('common.delete')"
                  @click.prevent="removePhone(phone)"
                />
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>-->
    </el-tabs>
    <el-alert v-if="formError" class="team-invitation-error" :title="formError" type="error" :closable="false" show-icon />
    <el-button v-if="formError && !inviteCode && !contextInvalid" class="invitation-retry" :loading="loading" @click="getInviteTeamCode()">
      {{ $t('common.refresh') }}
    </el-button>
    <div
      v-show="inviteInfo.expiration_time"
      class="re-set-box"
    >
      <span>{{ $t('views.user_center.invitation_expiry_time') }}{{ inviteInfo.expiration_time }}</span>
      <button
        class="reset-opt"
        type="button"
        :disabled="loading || saveLoading"
        @click="getInviteTeamCode(1)"
      >
        <el-icon>
          <RefreshRight />
        </el-icon>
        {{ $t('views.user_center.reset') }}
      </button>
    </div>
  </div>
</template>

<script>

import { getInviteCode, getCurrTeamInfo, inviteJoinTeam } from '@/api/team'
import { markRaw } from 'vue'
import QRCode from 'qrcodejs2'
import 'intl-tel-input/build/css/intlTelInput.css'
import intlTelInput from 'intl-tel-input'
import { writeTextToClipboard } from '@/utils/clipboard'

export default {
  name: 'TeamInvitation',
  components: {},
  emits: ['confirm-end', 'busy-change'],
  props: {
    isDialog: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inviteType: 'qrcode',
      inviteLink: '',
      inviteCode: '',
      inviteSearch: '',
      inviteSearchUserList: [],
      invitePhoneForm: {
        phones: [{ value: '', key: 1 }]
      },
      inviteEmailForm: {
        emails: [{ value: '', key: Date.now() }]
      },
      teamInfo: {
        avatar: ''
      },
      qrcode: null,
      qrCodeImgIsLoad: false,
      inviteInfo: {},
      loading: false,
      saveLoading: false,
      formError: '',
      phoneSequence: 1,
      codeRequestSerial: 0,
      submitSerial: 0,
      contextInvalid: false,
      contextRefreshSerial: 0,
      disposed: false
    }
  },
  computed: {
    businessContext() {
      return `${this.$store.getters.user_id || ''}:${this.$store.getters.current_team_id || ''}`
    }
  },
  watch: {
    saveLoading(value) {
      this.$emit('busy-change', value)
    },
    businessContext() {
      const refreshSerial = ++this.contextRefreshSerial
      this.codeRequestSerial += 1
      this.submitSerial += 1
      this.contextInvalid = true
      this.loading = false
      this.saveLoading = false
      this.inviteLink = ''
      this.inviteCode = ''
      this.inviteInfo = {}
      this.teamInfo = {}
      this.qrCodeImgIsLoad = false
      this.formError = this.$t('common.account_identity_changed_refresh_required')
      this.$nextTick(() => {
        if (this.disposed || refreshSerial !== this.contextRefreshSerial) return
        this.contextInvalid = false
        this.getInviteTeamCode()
        this.getCurrTeamInfoData()
      })
    }
  },
  mounted() {
    this.getInviteTeamCode()
    this.getCurrTeamInfoData()
  },
  beforeUnmount() {
    this.disposed = true
    this.codeRequestSerial += 1
    this.submitSerial += 1
    this.$emit('busy-change', false)
    this.invitePhoneForm.phones.forEach(phone => {
      if (phone.iti) phone.iti.destroy()
    })
    this.qrcode = null
  },
  methods: {
    choiceInviteType() {
      if (this.inviteType === 'phone') {
        this.initTelInputSelect()
      }
    },
    async inviteLinkCopy(refName) {
      const value = refName === 'inviteCode' ? this.inviteCode : this.inviteLink
      if (this.loading || this.contextInvalid || !value) return
      const copied = await writeTextToClipboard(value || '')
      if (this.disposed || this.contextInvalid) return
      this.$message({
        message: this.$t(copied ? 'common.copy_success' : 'common.copy_failed'),
        type: copied ? 'success' : 'error',
        customClass: 'message_index'
      })
    },
    submitOption() {
      if (this.saveLoading || this.loading || this.contextInvalid || this.disposed) return
      if (this.inviteType === 'phone' || this.inviteType === 'mail') {
        this.submitInviteForm()
      } else {
        this.$emit('confirm-end')
      }
    },
    async submitInviteForm() {
      if (this.saveLoading || this.loading || this.contextInvalid || this.disposed) return
      const type = this.inviteType
      const form = type === 'phone' ? this.$refs.invitePhoneForm : type === 'mail' ? this.$refs.inviteEmailForm : null
      if (!form) return
      const serial = ++this.submitSerial
      const context = this.businessContext
      const isCurrent = () => !this.disposed && !this.contextInvalid && serial === this.submitSerial && context === this.businessContext
      this.formError = ''
      this.saveLoading = true
      try {
        const valid = await form.validate().catch(() => false)
        if (!valid || !isCurrent()) return
        const params = { type: type === 'phone' ? 1 : 0 }
        if (type === 'phone') {
          const phoneList = this.invitePhoneForm.phones.map(phone => {
            const country = phone.iti && phone.iti.getSelectedCountryData()
            return { country_code: country && country.dialCode, value: phone.value }
          })
          if (!phoneList.length || phoneList.some(phone => !phone.country_code)) {
            this.formError = this.$t('views.user_center.please_fill_in_the_invitation_form')
            return
          }
          params.phone_list = phoneList
        } else {
          params.email_list = this.inviteEmailForm.emails.map(email => email.value)
          if (!params.email_list.length) {
            this.formError = this.$t('views.user_center.please_fill_in_the_invitation_email')
            return
          }
        }
        const response = await inviteJoinTeam(params)
        if (!isCurrent()) return
        if (!response || ![0, 200].includes(Number(response.code))) {
          this.formError = this.$t('common.operation_failed')
          return
        }
        this.$message({
          message: this.$t('views.user_center.team_as_soon_as_possible3'),
          type: 'success'
        })
        this.$emit('confirm-end')
      } catch (error) {
        if (isCurrent()) this.formError = error && error.message ? error.message : this.$t('common.operation_failed')
      } finally {
        if (isCurrent()) this.saveLoading = false
      }
    },
    async getInviteTeamCode(is_reset = 0) {
      if (this.loading || this.saveLoading || this.contextInvalid || this.disposed) return
      const serial = ++this.codeRequestSerial
      const context = this.businessContext
      const isCurrent = () => !this.disposed && !this.contextInvalid && serial === this.codeRequestSerial && context === this.businessContext
      this.formError = ''
      this.loading = true
      try {
        const response = await getInviteCode({ is_reset: is_reset })
        if (!isCurrent()) return
        if (!response || ![0, 200].includes(Number(response.code)) || !response.data || !response.data.invite_code) {
          this.formError = this.$t('common.operation_failed')
          return
        }
        this.buildInviteData(response.data)
      } catch (error) {
        if (isCurrent()) this.formError = error && error.message ? error.message : this.$t('common.operation_failed')
      } finally {
        if (isCurrent()) this.loading = false
      }
    },
    getCurrTeamInfoData() {
      const context = this.businessContext
      getCurrTeamInfo({}).then(response => {
        if (!this.disposed && !this.contextInvalid && context === this.businessContext && response && [0, 200].includes(Number(response.code))) {
          this.teamInfo = response.data
        }
      }).catch(() => {

      })
    },
    buildInviteData(data) {
      this.inviteInfo = data
      const code = data.invite_code
      const host = window.location.origin
      this.inviteLink = host + '/join-team/' + code
      this.inviteCode = code
      this.drawTeamQrcode()
    },
    drawTeamQrcode() {
      const host = this.$refs.teamInviteQrCode
      if (!host || this.disposed) return
      host.innerHTML = ''
      this.qrCodeImgIsLoad = false
      const qrcode = new QRCode(host, {
        render: 'table',
        text: this.inviteLink,
        width: 200,
        height: 200,
        colorDark: '#333333',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.L
      })
      this.qrcode = markRaw(qrcode)
      const image = qrcode._oDrawing && qrcode._oDrawing._elImage
      if (image) {
        image.onload = () => {
          if (!this.disposed && !this.contextInvalid && this.qrcode === qrcode) this.drawimgObjects()
        }
      }
      this.drawimgObjects()
    },
    drawimgObjects() {
      if (this.disposed || this.contextInvalid || !this.qrcode) return
      const drawing = this.qrcode._oDrawing
      const source = drawing && (drawing._elCanvas || (drawing._elImage && drawing._elImage.complete && drawing._elImage))
      const canvas = this.$refs.teamQrCodeCanvas
      if (!source || !canvas) return
      const context = canvas.getContext('2d')
      if (!context) return
      context.clearRect(0, 0, canvas.width, canvas.height)
      context.drawImage(source, 0, 0, 200, 200)
      this.qrCodeImgIsLoad = true
    },
    downQrcodeImg() {
      if (this.loading || !this.qrCodeImgIsLoad || this.contextInvalid || this.disposed) return
      try {
        this.$refs.qrCodedownload.href = this.$refs.teamQrCodeCanvas.toDataURL('image/png')
        this.$refs.qrCodedownload.click()
      } catch (error) {
        this.formError = this.$t('common.operation_failed')
      }
    },
    validatePhone(rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$t('views.user_center.please_enter_your_mobile_number')))
      } else {
        var getIndexReg = rule.fullField.match(/\d+/)
        var isChina = false
        if (getIndexReg && getIndexReg[0]) {
          if (this.invitePhoneForm.phones[getIndexReg[0]] && this.invitePhoneForm.phones[getIndexReg[0]].iti) {
            var countryData = this.invitePhoneForm.phones[getIndexReg[0]].iti.getSelectedCountryData()
            if (countryData && countryData.dialCode === '86') {
              isChina = true
            }
          }
        }
        if (isChina) {
          if (!/^1[3456789]\d{9}$/.test(value)) {
            callback(new Error(this.$t('views.user_center.the_correct_mobile_phone_number')))
          } else {
            callback()
          }
        } else {
          if (!/^\d+$/.test(value)) {
            callback(new Error(this.$t('views.user_center.the_correct_mobile_phone_number')))
          } else {
            callback()
          }
        }
      }
    },
    initTelInputSelect() {
      this.$nextTick(() => {
        if (this.disposed || this.contextInvalid) return
        this.invitePhoneForm.phones.forEach(phone => {
          const input = this.$el.querySelector('#team-invite-phone-' + phone.key)
          if (input && !phone.iti) {
            const iti = intlTelInput(input, {
              allowDropdown: true,
              initialCountry: 'cn',
              autoHideDialCode: true,
              formatOnDisplay: true,
              nationalMode: false,
              placeholderNumberType: 'MOBILE',
              separateDialCode: true,
              // Keep the dropdown inside the dialog focus trap across viewport changes.
              useFullscreenPopup: false,
              fixDropdownWidth: false
            })
            phone.iti = markRaw(iti)
          }
        })
      })
    },
    removePhone(item) {
      if (this.saveLoading || this.contextInvalid || this.invitePhoneForm.phones.length === 1) return
      var index = this.invitePhoneForm.phones.indexOf(item)
      if (index !== -1) {
        if (item.iti) item.iti.destroy()
        this.invitePhoneForm.phones.splice(index, 1)
      }
    },
    addPhone() {
      if (this.saveLoading || this.contextInvalid) return
      this.invitePhoneForm.phones.push({
        value: '',
        key: ++this.phoneSequence
      })
      this.initTelInputSelect()
    },
    async copyValue(message) {
      const copied = await writeTextToClipboard(message)
      this.$message({
        message: this.$t(copied ? 'common.copy_success' : 'common.copy_failed'),
        type: copied ? 'success' : 'error'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/views/user_center/components/invitation";
@import "@/views/mobile/user_center/styles/invitation";

.team-invite-code {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  color: var(--agst-text-color-regular, $text-color-regular);

  .team-invite-code-value {
    min-width: 0;
    overflow-wrap: anywhere;
    user-select: text;
  }
}
</style>
